import styled, { css } from 'styled-components';
import { colors } from '@nandosaus/constants';
import { variant as styledVariant } from 'styled-system';
import { P } from '../typography/new';

const greenHoverState = {
  backgroundColor: colors.neonTeal100,
  color: colors.neonTeal800,
  border: `1px solid ${colors.neonTeal100}`,
};

const activeState = {
  backgroundColor: colors.black,
  color: colors.white,
};

export const pillVariants = styledVariant({
  variants: {
    default: {
      backgroundColor: colors.warmWhite4,
      '&:hover': activeState,
    },
    active: {
      ...activeState,
    },
    plain: {},
  },
});

export const buttonVariants = styledVariant({
  variants: {
    default: {
      backgroundColor: colors.white,
      border: `1px solid ${colors.grey700}`,
      '&:hover': {
        border: `1px solid ${colors.neonTeal400}`,
      },
    },
    active: {
      backgroundColor: colors.black,
      border: `1px solid ${colors.black}`,
      color: colors.white,
    },
    plain: {
      border: `1px solid ${colors.white}`,
      backgroundColor: colors.white,
      '&:hover': greenHoverState,
    },
  },
});

const commonBaseStyles = css`
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${colors.black};
`;

export const StyledButtonPill = styled.button`
  border-radius: 4px;

  padding: 3px 12px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 5px 14px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 8px 16px;
  }

  ${commonBaseStyles}

  ${buttonVariants};
`;

export const StyledPill = styled.button`
  border-radius: 30px;

  padding: 8px 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 13px 20px;
  }

  ${commonBaseStyles}

  ${pillVariants};
`;

export const PillText = styled(P)`
  white-space: nowrap;
`;
